var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CContainer',{attrs:{"fluid":""}},[_c('div',{staticClass:"metro-menu"},[_c('div',{staticClass:"tile tile-12 small",on:{"click":() => {
        _vm.$router.push({ path: `${_vm.rootPath}/nominaelectronica`})
      }}},[_c('i',{staticClass:"bi bi-universal-access-circle"}),_c('span',[_vm._v("Nómina Electrónica")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }